<template>
  <CollapsibleWrapper :collapse="!showBanner">
    <div
      v-if="globalsStore.settings?.banner"
      class="py-3 text-center text-[16px]/[1.2em] font-normal"
      :style="bannerStyle"
    >
      <DefaultGrid>
        <div class="col-span-full">
          <span v-text="globalsStore.settings.banner.text" />
          &nbsp;
          <NuxtLink
            v-if="globalsStore.settings.banner.cta"
            :to="globalsStore.settings.banner.cta.url"
            class="group inline-flex items-center gap-x-1"
          >
            <span
              class="underline decoration-1 underline-offset-2 group-hover:no-underline"
              v-text="globalsStore.settings.banner.cta.label"
            />
            <span>→</span>
          </NuxtLink>
        </div>
      </DefaultGrid>
    </div>
  </CollapsibleWrapper>
</template>

<script setup lang="ts">
const globalsStore = useGlobalsStore()

const bannerStyle = computed(() => ({
  backgroundColor: globalsStore.settings?.banner?.backgroundColour || '#000000',
  color: globalsStore.settings?.banner?.textColour || '#FFFFFF',
}))

const showBanner = ref(false)

onMounted(() => {
  if (globalsStore.settings?.banner?.isEnabled) {
    setTimeout(() => {
      showBanner.value = true
    }, 1000)
  }
})
</script>
